export default "__VITE_ASSET__BrAUxXCy__"